import TaskDetailedViewLoader from './TaskDetailedViewLoader'
export default TaskDetailedViewLoader
